import { IonAlert, IonButton, IonGrid, IonItem } from '@ionic/react';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import AmountPaid from '../../components/amountPaid';
import Box, { BoxHeader } from '../../components/box';
import { NormalText, SmallText, Spacer, StrongText, Subtitle, Title } from '../../components/common';
import Layout from '../../components/layout';
import OrderContent from '../../components/orderContent';
import Basket, { createNewBasketInstance } from '../../lib/basket';
import moment from '../../lib/moment';
import { withTranslation } from '../../lib/translate';
import { forwardTo, getDefaultRoute, isEmptyObject, sendToAnalytics, formatOrderForAnalytics } from '../../lib/utils';
import { loading, logout } from '../../store/actions';
import { GET_ORDER_HISTORY, SEND_GIFT_VOUCHER, UPDATE_STRIPE_ORDER } from '../../store/constants';
import { checkCancelOrder, setOrdersProp } from '../../store/orders/actions';
import { Browser } from '@capacitor/browser';
import api from '../../lib/api';
import './index.css';
import { getConfig } from '../../appConfig';
import OrderStatus from '../../components/orderStatus';
import OrderCustomMessage from '../../components/orderCustomMessage';
import { ReactComponent as LocationIcon } from '../../assets/images/distance.svg';
import { ReactComponent as TimeIcon } from '../../assets/images/acute.svg';
import { ReactComponent as TableIcon } from '../../assets/images/picnic-table.svg';

const isWeb = () => Capacitor.getPlatform() === 'web';

class OrderCompleted extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isCancel: false,
			orderId: null,
			restaurantId: null,
			urlParamsAreLoaded: false,
		};
		if (!isWeb()) {
			if (window.mobileApp) {
				window.mobileApp.close();

			} else {
				Browser.close();
			}
		}
	}

	// Fires the GA4 `purchase` conversion event once a checkout has genuinely completed.
	// This screen is the single convergence point for every payment flow (standard/Square land
	// here only after payment is confirmed; Yoco/Prebuild redirect back here on success), so the
	// event is emitted here instead of in the individual order sagas. Deduped per order id so the
	// hosted-checkout redirect reload (or a later revisit) cannot double-count a conversion.
	trackPurchaseAnalytics = () => {
		const searchParams = new URLSearchParams(this.props.location.search);
		const status = searchParams.get('status');
		if (status === 'failure' || status === 'canceled' || status === 'cancel') {
			return;
		}
		const order = this.props.order || this.props.lastOrder;
		if (!order || !order.id) {
			return;
		}
		const dedupeKey = `ga_purchase_fired_${order.id}`;
		try {
			if (window.localStorage.getItem(dedupeKey)) {
				return;
			}
			sendToAnalytics('purchase', formatOrderForAnalytics(order, Basket.getOrderType(order)));
			window.localStorage.setItem(dedupeKey, '1');
		} catch (error) {
			console.log('Error_sending_purchase_analytics', error);
		}
	};

	componentDidUpdate(prevProps) {
		this.trackPurchaseAnalytics();
		const searchParams = new URLSearchParams(this.props.location.search);
		if (!this.state.urlParamsAreLoaded && searchParams.get('status')) {
			const status = searchParams.get('status');
			this.setState({ urlParamsAreLoaded: true }, () => {
				if (status === 'success' || status === 'failure') {
					Basket.reset();
				} else if (status === 'canceled' || status === 'cancel') {
					forwardTo('/order');
				}
			});
		}
		if (this.props.lastOrder) {
			if (prevProps.lastOrder === null || prevProps.lastOrder.id !== this.props.lastOrder.id) {
				const { lastOrder } = this.props;
				const orderArr = lastOrder;
				const now = moment();
				let cutoffTime = orderArr ? orderArr.cutoff_time : now;
				let cutoffTimeMoment = new moment(cutoffTime, 'YYYY-MM-DD HH:mm:ss');
				const utcOffset = cutoffTimeMoment.utcOffset();
				cutoffTimeMoment = cutoffTimeMoment.add('minutes', utcOffset);
				if (now.isBefore(cutoffTimeMoment)) {
					this.setState({
						isCancel: true,
						orderId: orderArr.id,
						restaurantId: orderArr.restaurant_id,
					});
				}
			}
		}
	}

	drawContentTitle = (__, deliveryOption, id, orderType) => {
		if (orderType === 'Outpost Drop-Off') {
			return (
				<Title className='page-title-centered'>
					{__('Drop Point')} {__('Order')} #{id}
				</Title>
			);
		} else if (orderType === 'Delivery') {
			return (
				<Title className='page-title-centered'>
					{__('Delivery')} {__('Order')} #{id}
				</Title>
			);
		} else if (orderType === 'Table') {
			return (
				<Title className='page-title-centered'>
					{__('At Table')} {__('Order')} #{id}
				</Title>
			);
		} else if (orderType === 'scheduled-collection') {
			return (
				<Title className='page-title-centered'>
					{__('Click & Collect')} #{id}
				</Title>
			);
		} else if (orderType === 'scheduled-delivery') {
			return (
				<Title className='page-title-centered'>
					{__('Delivery')} #{id}
				</Title>
			);
		} else if (orderType === 'pick-up-at-counter') {
			return (
				<Title className='page-title-centered'>
					{__('Pickup at Counter')} #{id}
				</Title>
			);
		} else {
			return (
				<Title className='page-title-centered'>
					{__(orderType)} #{id}
				</Title>
			);
		}
	};

	drawContent = (__, order, orderType, basketInstance, status) => {
		if (!order?.is_gift && !order?.is_event) {
			if (orderType === 'Click & Collect') {
				return (
					<>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div><StrongText className='text-to-update'>{__('Collection details')}</StrongText></div>
							<div className="order-status-wrapper">
								<div>{status && __(status)}</div>
							</div>
						</div>
						<Spacer size={2} />
						<OrderCustomMessage __={__} orderType={basketInstance.order_type} />
						<div className="box-content order-content-details">
							<>
								{!order.has_multi_basket && (
									<div>
										<LocationIcon className='fill-label' />
										<StrongText className="block text-to-update">{order.restaurant_name}</StrongText>

									</div>
								)}
								<div>
									<TimeIcon className='fill-label' />{' '}
									<NormalText className="block">
										{__('Collection time')}
									</NormalText>
									<NormalText className="block">{order.is_asap ? this.props.__('ASAP') : basketInstance.formatOrderTime(this.props.__, true, 'Do MMM h:mm a')}</NormalText>
								</div>


							</>
						</div>
					</>
				);
			} else if (orderType === 'Delivery') {
				return (
					<>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div><StrongText className='text-to-update'>{__('Order details')}</StrongText></div>
							<div className="order-status-wrapper">
								<div>{status && __(status)}</div>
							</div>
						</div>
						<Spacer size={2} />
						<OrderCustomMessage __={__} orderType={basketInstance.order_type} />

						<div className="box-content order-content-details">
							{!order.has_multi_basket && (
								<div>
									<LocationIcon className='fill-label' />
									<StrongText className="block text-to-update">{order.restaurant_name}</StrongText>
								</div>
							)}
							<div>
								<TimeIcon className='fill-label' />
								<NormalText className="block">
									{__('Delivery time')}
								</NormalText>
								<NormalText className="block">{order.is_asap ? this.props.__('ASAP') : basketInstance.formatOrderTime(this.props.__, true, 'Do MMM h:mm a')}</NormalText>
							</div>
							<Spacer size={2} />
							<div style={{ alignItems: 'flex-start' }}>
								<LocationIcon className='fill-label' />
								<div>

									<NormalText className="block">
										{__('Delivery to')}
									</NormalText>
									<NormalText className="block">{[order.delivery_address?.addressLine1, order.delivery_address?.addressLine2, order.delivery_address?.place, order.delivery_address?.postalCode].filter(Boolean).join(', ')}</NormalText>
								</div>
							</div>

						</div>
					</>
				);
			} else if (orderType === 'Outpost Drop-Off') {
				return (
					<>
						<OrderCustomMessage __={__} orderType={basketInstance.order_type} />
						<div className="box-content order-content-details">
							<div>
								{!order.has_multi_basket && (
									<>
										<StrongText>{__('Drop-off at')}</StrongText>
										<StrongText className="block text-to-update">{order.restaurant_name}</StrongText>
									</>
								)}
								<SmallText className="block">
									{__('Order placed on')}: {moment(order.created_at).format('Do MMM h:mm a')}
								</SmallText>
								<SmallText className="block">
									{__('Drop-off Time')}: {basketInstance.formatOrderTime(this.props.__, true)}
								</SmallText>
							</div>
							<div className="order-status-wrapper">
								<div>{status && __(status)}</div>
							</div>
						</div>
					</>
				);
			} else if (orderType === 'Table') {
				return (
					<>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div><StrongText className='text-to-update'>{__('Order table details')}</StrongText></div>
							<div className="order-status-wrapper">
								<div>{status && __(status)}</div>
							</div>
						</div>
						<Spacer size={2} />
						<OrderCustomMessage __={__} orderType={basketInstance.order_type} />

						<div className="box-content order-content-details">
							{!order.has_multi_basket && (
								<div>
									<LocationIcon className='fill-label' />
									<StrongText className="block text-to-update">{order.restaurant_name}</StrongText>
								</div>
							)}
							<div>
								<TableIcon className='fill-label' />
								<NormalText className="block">
									{__('Table Number')}
								</NormalText>
								<NormalText className="block">{order.table_name}</NormalText>
							</div>


						</div>
					</>
				);
			} else if (orderType === 'scheduled-collection') {
				return (
					<>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div><StrongText className='text-to-update'>{__('Order details')}</StrongText></div>
							<div className="order-status-wrapper">
								<div>{status && __(status)}</div>
							</div>
						</div>
						<Spacer size={2} />
						<OrderCustomMessage __={__} orderType={basketInstance.order_type} />

						<div className="box-content order-content-details">
							{!order.has_multi_basket && (
								<div>
									<LocationIcon className='fill-label' />
									<StrongText className="block text-to-update">{order.restaurant_name}</StrongText>
								</div>
							)}
							<div>
								<TimeIcon className='fill-label' />{' '}
								<NormalText className="block">
									{__('Collection time')}
								</NormalText>
								<NormalText>
									{basketInstance.additional_data?.named_time_slots_data ? (
										<>
											{basketInstance.formatOrderTime(this.props.__, true, 'DD MMM YYYY')} {__('at')} {basketInstance.additional_data?.named_time_slots_data}
										</>
									) : (
										<>
											{basketInstance.formatOrderTime(this.props.__, true, 'Do MMM h:mm a')}
										</>
									)}
								</NormalText>
							</div>

						</div>
					</>
				);
			} else if (orderType === 'pick-up-at-counter') {
				return (
					<>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div><StrongText className='text-to-update'>{__('Order details')}</StrongText></div>
							<div className="order-status-wrapper">
								<div>{status && __(status)}</div>
							</div>
						</div>
						<Spacer size={2} />
						<OrderCustomMessage __={__} orderType={basketInstance.order_type} />

						<div className="box-content order-content-details">
							{!order.has_multi_basket && (
								<div>
									<LocationIcon className='fill-label' />
									<StrongText className="block text-to-update">{order.restaurant_name}</StrongText>
								</div>
							)}
							<div>
								<TimeIcon className='fill-label' />
								<NormalText className="block">
									{__('Collection time')}
								</NormalText>
								<NormalText className="block">{__('ASAP')}</NormalText>
							</div>



						</div>
					</>
				);
			} else if (orderType === 'scheduled-delivery') {
				return (
					<>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div><StrongText className='text-to-update'>{__('Order details')}</StrongText></div>
							<div className="order-status-wrapper">
								<div>{status && __(status)}</div>
							</div>
						</div>
						<Spacer size={2} />
						<OrderCustomMessage __={__} orderType={basketInstance.order_type} />

						<div className="box-content order-content-details">
							{!order.has_multi_basket && (
								<div>
									<LocationIcon className='fill-label' />
									<StrongText className="block text-to-update">{order.restaurant_name}</StrongText>
								</div>
							)}
							<div>
								<TimeIcon className='fill-label' />
								<NormalText className="block">
									{__('Delivery time')}
								</NormalText>
								<NormalText className="block">{basketInstance.formatOrderTime(this.props.__, true, 'Do MMM h:mm a')}</NormalText>
							</div>
							<Spacer size={2} />
							<div style={{ alignItems: 'flex-start' }}>
								<LocationIcon className='fill-label' />
								<div>

									<NormalText className="block">
										{__('Delivery to')}
									</NormalText>
									<NormalText className="block">{[order.delivery_address?.addressLine1, order.delivery_address?.addressLine2, order.delivery_address?.place, order.delivery_address?.postalCode].filter(Boolean).join(', ')}</NormalText>
								</div>
							</div>

						</div>
					</>
				);
			}
		} else {
			return <></>;
		}
	};
	drawOrder = (order, orderCompletePage) => {
		const { __, lastOrder, cards } = this.props;
		const { id, menu_item_placeholder_image } = order;
		const basketInstance = createNewBasketInstance();
		basketInstance.recreateOrder(order);
		const orderType = basketInstance.getOrderType();
		const status = getConfig().flags.removeOrderStatus ? null : lastOrder?.status
		const restaurantMenuItemImage = menu_item_placeholder_image || null
		return (
			<>


				<div className="web-only">{this.drawContentTitle(__, Basket.getDeliveryOption(), id, basketInstance.getOrderType())}</div>

				{order?.additional_data?.uber?.error &&
					<div className='invalid-uber-order'>
						<StrongText>{order.additional_data.uber.error.message}</StrongText>
						<Spacer size={0} />
						{Object.values(order.additional_data.uber.error.metadata).map((el, index) => (
							<NormalText key={`additional-data-uber_${index}`}>{el}</NormalText>
						))}
						<Spacer size={0} />
						<NormalText>{__('Please contact support.')}</NormalText>
					</div>
				}
				{this.drawContent(__, order, orderType, basketInstance, status)}

				<Spacer size={5} />
				<OrderContent restaurantMenuItemImage={restaurantMenuItemImage} basketInstance={basketInstance} type="orderHistory" totalClass="uppercase" totalBorderedBottom={true} />
				{!order.is_gift && !order.is_event && order.events.length > 0 && getConfig().flags.hasOrderStatus && (
					<>
						<Spacer size={5} />

						<OrderStatus events={order.events} />
						<Spacer size={5} />
					</>
				)}
				<AmountPaid className="card-label" order={order} cards={cards} />
				{this.props.profile.is_guest && (
					<IonButton
						className='button-uppercase'
						color="primary"
						expand="block"
						onClick={() => {
							this.props.dispatch(logout());
						}}
					>
						{__('Done')}
					</IonButton>
				)}
			</>
		);
	};

	cancelOrder = () => {
		const { orderId, isCancel, restaurantId } = this.state;
		if (isCancel) {
			this.props.dispatch(checkCancelOrder(orderId, restaurantId));
			this.setState({ orderId: null, isCancel: false, restaurantId: null });
		}
	};

	noOrder = () => (
		<IonItem lines="none">
			<div className="sectiontitle" style={{ width: '100vh', textAlign: 'center' }}>
				{this.props.__('No order')}
			</div>
		</IonItem>
	);

	backHandler = () => {
		const { location } = this.props;
		if (location && location.state && location.state.completedOrder) {
			Basket.reset();
			const defaultRoute = getDefaultRoute(this.props.navConfig);
			forwardTo(defaultRoute.path);
		}
	};

	handleCancelOrderModal = (flag) => {
		this.props.dispatch(setOrdersProp('cancelOrderModal', flag));
	};
	async componentDidMount() {
		this.trackPurchaseAnalytics();
		this.props.dispatch({ type: GET_ORDER_HISTORY, loading: false })
		const searchParams = new URLSearchParams(this.props.location.search);
		const status = searchParams.get('status');
		const canceled = searchParams.get('canceled');

		const lastOrder = this.props.lastOrder;
		if (lastOrder && status == 'canceled' && lastOrder?.status?.toLowerCase() == 'new') {
			this.props.dispatch({ type: UPDATE_STRIPE_ORDER, orderId: lastOrder.id });
		}
		if (lastOrder?.is_gift && lastOrder.additional_data.gift_voucher_data) {
			if (!canceled && status !== 'failure' && status !== 'canceled' && status !== 'cancel') {
				const giftVoucherData = lastOrder.additional_data.gift_voucher_data
				giftVoucherData.order_id = lastOrder.id
				const sentVouchers = await api.getSentGiftVouchers()
				const isVoucherSent = sentVouchers.filter(voucher => voucher.order_id == lastOrder.id).length > 0
				if (isVoucherSent) {
					forwardTo('/sent-vouchers')
				} else {
					this.props.dispatch({
						type: SEND_GIFT_VOUCHER,
						data: giftVoucherData,
					});
				}

			} else {
				forwardTo('/gift-vouchers')
			}
		}

		if (status === 'success' || status === 'failure') {
			Basket.reset();
		} else if (status === 'canceled' || status === 'cancel') {
			forwardTo('/order');
		}
	}

	render() {
		const { __, lastOrder } = this.props;
		const order = this.props.order || lastOrder;
		const orderCompletePage = true;
		const headerLabel = `${__('Order')} ${order?.id && `#${order.id}`}`;
		return (
			<Layout color="transparent" backHandler={this.backHandler} title={__(headerLabel)} headerWithTitle={true}>
				<div className="absolute-content order-details">
					{!order?.is_gift && !order?.is_event &&
						<div >{order ? this.drawOrder(order, orderCompletePage) : this.noOrder()}</div>
					}
				</div>
				<IonAlert
					isOpen={this.props.cancelOrderModal === true}
					onDidDismiss={() => this.handleCancelOrderModal(false)}
					message={__('Do you want to cancel this order?')}
					buttons={[
						{
							cssClass: 'primary',
							text: __('Remove'),
							handler: () => this.cancelOrder(),
						},
						{
							text: __('Cancel'),
							role: 'cancel',
							cssClass: 'secondary link',
						},

					]}
				/>
			</Layout>
		);
	}
}

const mapStateToProps = (store) => {
	const orders = store.orders;
	const { navConfig } = store.common;
	const { cancelOrderModal } = orders;
	const { restaurants } = store.restaurants;
	let lastOrder = null;
	const orderHistory = orders.orderHistory;
	if (orderHistory && orderHistory.length > 0) {
		lastOrder = orderHistory[0];
	}
	const { profile } = store.profile;

	return {
		lastOrder,
		cards: orders.cards || [],
		restaurants: restaurants || [],
		cancelOrderModal,
		profile,
		navConfig,
	};
};

export default connect(mapStateToProps)(withRouter(withTranslation(OrderCompleted)));
